<script>
import { AppLayout, PageHeader } from '@/components/layout'
import appConfig from '@/app.config'

import WelcomeCard from './shared/welcome-card'
import LatestOrdersCard from './shared/latest-orders-card'
import OrdersSummaryCard from './shared/orders-summary-card'
import CartInfo from './shared/cart-info'
import RejectedOrders from './shared/rejected-orders'
import OrdersStatCard from './shared/orders-stat-card.vue'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    AppLayout,
    PageHeader,
    WelcomeCard,
    CartInfo,
    LatestOrdersCard,
    OrdersStatCard

    //OrdersSummaryCard,

    //RejectedOrders
  },
  data () {
    return {
      title: 'Dashboard',
      items: [
        {
          text: 'Dashboards',
          href: '/'
        },
        {
          text: 'Home',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <AppLayout>
    <PageHeader :title="$t('dashboard')" :items="items" />

    <welcome-card />

    <b-card-group columns>
      <orders-stat-card status="open" />
      <orders-stat-card status="processing" />
      <orders-stat-card status="complete" />
    </b-card-group>

    <cart-info />

    <b-card-group deck class="mb-3">
      <latest-orders-card :length="5" />
    </b-card-group>
  </AppLayout>
</template>
